module.exports = __webpack_public_path__ + "media/application/images/red-rectangle-1420427b2451d47b9e54b0d8061c6506.svg";